import { Routes } from '@angular/router';
import { ConnectionDetailComponent, ConnectionsComponent, ContactPlacesComponent, DeparturesComponent, MainComponent, StopsComponent } from './main/';
import { NotFoundComponent } from './pages/not-found.component';

export const routes: Routes = [
  {
    path: '', component: MainComponent,
    children: [
      { path: 'connections', component: ConnectionsComponent },
      { path: 'stops', component: StopsComponent },
      { path: 'contactPlaces', component: ContactPlacesComponent },
      { path: 'contactPlaces/:id', component: ContactPlacesComponent },
      { path: 'departures/:id', component: DeparturesComponent },
      { path: 'detail/:id', component: ConnectionDetailComponent },
      { path: 'detail/:id/:stopId', component: ConnectionDetailComponent }
    ]
  },
  { path: '**', component: NotFoundComponent }
];
